export default __webpack_public_path__ + "static/media/elevate-bpn-2.9c7ea48a.png";